module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/particular05-b2970225e701a4cd24f552f1945a8ca6.png";